export default "__VITE_ASSET__knfL6E3oZJN2Af0ANlqNJg__"